/* eslint-disable max-lines */
import type { PageType } from '@app-types/PageType'
import { bundledDuaDescriptors } from '../../packages/content/src/dua-metadata'

const contentLibraryEntries: {
  type: PageType
  name: string
  url: string
  keywords: string
  color: string
  pageName?: string
  basePath?: string
  pageCount?: number
  infoVideo?: string
  contentVideo?: string
  estReadTime?: number
  fileName?: string
  isNew?: boolean
  sound?: boolean
}[] = [
  {
    name: 'Kuran-ı Kerim',
    type: 'kuran',
    url: 'kuran',
    keywords: 'kuran kerim',
    color: '#00d0ff',
    estReadTime: 45,
  },
  {
    name: 'Cevşen-i Şerif',
    type: 'cevsen',
    url: 'cevsen',
    keywords: 'cevsen cevseni serif ',
    color: '#ff7a05',
    pageCount: 10,
    infoVideo: 'https://www.youtube.com/embed/aj-FYhfEEfc?si=aUiTreDAgSKA-M_i',
  },
  {
    name: 'Cevşen-i Şerif (Tekli)',
    type: 'cevsen-i-serif',
    url: 'dualar/cevsen-i-serif',
    basePath: '/dualar',
    pageName: 'Bâb',
    keywords: 'cevsen-i-serif tekli dua zikir cevşen-i serif',
    color: '#f8a5c2',
    infoVideo: 'https://www.youtube.com/embed/aj-FYhfEEfc?si=aUiTreDAgSKA-M_i',
    pageCount: 101,
    fileName: 'cevsen',
  },
  {
    name: 'Celcelutiye',
    type: 'celcelutiye',
    url: 'dualar/celcelutiye',
    basePath: '/dualar',
    keywords: 'celce celcelütiye',
    color: '#f87272',
    pageCount: 10,
    infoVideo: 'https://www.youtube.com/embed/lXF_P_cP8MI?si=8NBVMw5Ijsz3ZP4l',
    fileName: 'celce',
  },
  {
    name: 'Evrad-ı Kudsiye',
    type: 'evrad-i-kudsiye',
    url: 'dualar/evrad-i-kudsiye',
    basePath: '/dualar',
    keywords: 'evradi kudsiye dua',
    color: '#21e47f',
    pageCount: 10,
    infoVideo:
      'https://www.youtube.com/embed/6L5tU8hOXac?si=aIfPWE1h2g3OTVJa&amp;start=319',
    fileName: 'evradiKudsiye',
  },
  {
    name: 'Sabah Duaları',
    type: 'sabah-dualari',
    url: 'dualar/sabah-dualari',
    basePath: '/dualar',
    keywords: 'sabah dua zikir sabah Duaları',
    color: '#c107',
    pageCount: 3,
    contentVideo: 'https://www.youtube.com/embed/5g0siHbcO6U?si=d-76xuux_sxnPMe7',
    fileName: 'sabahDuasi',
  },
  {
    name: 'Akşam Duaları',
    type: 'aksam-dualari',
    url: 'dualar/aksam-dualari',
    basePath: '/dualar',
    keywords: 'aksam dua zikir aksam Duaları',
    color: '#4285f4',
    pageCount: 3,
    fileName: 'aksamDuasi',
  },
  {
    name: 'Tahmidiye',
    type: 'tahmidiye-duasi',
    url: 'dualar/tahmidiye-duasi',
    basePath: '/dualar',
    keywords: 'tahmidiye-duasi dua zikir tahmidiye Duası',
    color: '#a55eea',
    pageCount: 20,
    infoVideo:
      'https://www.youtube.com/embed/6L5tU8hOXac?si=wGeBd7T03U4JF3k9&amp;start=860',
    contentVideo: 'https://www.youtube.com/embed/GOa1P2KRArI?si=T5BRFG-n0dkGp0Zk',
    fileName: 'tahmidiye',
  },
  {
    name: 'Ashab-ı Bedir',
    type: 'ashab-i-bedir',
    url: 'dualar/ashab-i-bedir',
    basePath: '/dualar',
    keywords: 'ashab-i-bedir dua zikir ashab-ı Bedir ashabi bedir',
    color: '#f8a5c2',
    pageCount: 10,
    fileName: 'ashabiBedir',
  },
  {
    name: 'Şüheda-i Uhud',
    type: 'suheda-i-uhud-duasi',
    url: 'dualar/suheda-i-uhud-duasi',
    basePath: '/dualar',
    keywords:
      'ashab-i-uhud dua zikir suheda-ı Uhud suhedi uhud, suheda-i uhud duası, şüheda-i uhud duası',
    color: '#f8a5c2',
    pageCount: 9,
    fileName: 'ashabiUhud',
  },
  {
    name: 'Sekine',
    type: 'sekine-duasi',
    url: 'dualar/sekine-duasi',
    basePath: '/dualar',
    keywords: 'sekine-duasi dua zikir sekine Duası, ferdun',
    color: '#f8a5c2',
    pageCount: 2,
    fileName: 'sekineDuasi',
  },
  {
    name: 'Peygamber Efendimizin Duaları',
    type: 'peygamber-efendimizin-dualari',
    url: 'dualar/peygamber-efendimizin-dualari',
    basePath: '/dualar',
    keywords: 'peygamberimizin duaları, dua, hadis, sünnet, efendimizin duaları',
    color: '#f8a5c2',
    pageCount: 3,
    fileName: 'peygamberDualari',
  },
  {
    name: 'İsmi Azam',
    type: 'ismi-azam-duasi',
    url: 'dualar/ismi-azam-duasi',
    basePath: '/dualar',
    keywords: 'ismi-azam-duasi, dua, zikir, İsmi Azam Duası',
    color: '#f8a5c2',
    pageCount: 3,
    fileName: 'ismiAzamDuasi',
  },
  {
    name: 'Tercûman-i İsmi Azam',
    type: 'tercumani-ismi-azam-duasi',
    url: 'dualar/tercumani-ismi-azam-duasi',
    basePath: '/dualar',
    keywords: 'tercumani-ismi-azam-duasi, dua, zikir, Tercûman-i İsmi Azam Duası',
    color: '#f8a5c2',
    pageCount: 6,
    fileName: 'tercumaniIsmiAzamDuasi',
  },
  {
    name: 'Veysel Karani Munâcâtı',
    type: 'veysel-karani-munacati',
    url: 'dualar/veysel-karani-munacati',
    basePath: '/dualar',
    keywords:
      'veysel-karani-munacati, dua zikir, Veysel Karani Munacatı, veysel karani duası',
    color: '#f8a5c2',
    pageCount: 2,
    fileName: 'veyselKaraniMunacati',
  },
  {
    name: "Delailü'l Nur",
    type: 'delailul-nur',
    url: 'dualar/delailul-nur',
    basePath: '/dualar',
    keywords: 'delailul nur, dua zikir, Delailul Nur, delail nur',
    color: '#f8a5c2',
    pageCount: 14,
    fileName: 'delailulHayratDuasi',
  },
  {
    name: 'Kumeyl',
    type: 'kumeyl-duasi',
    url: 'dualar/kumeyl-duasi',
    basePath: '/dualar',
    keywords: 'kumeyl-duası dua zikir kumeyl Duası',
    color: '#ffc107',
    pageCount: 7,
    fileName: 'kumeylDuasi',
  },
  {
    name: "Hulasatü'l Hulasa",
    type: 'hulasatul-hulasa',
    url: 'dualar/hulasatul-hulasa',
    basePath: '/dualar',
    keywords: 'hulasatül hulasa, dua zikir, Hulasatül Hulasa, hulasat hulasa',
    color: '#f8a5c2',
    pageCount: 13,
    fileName: 'hulasatulHulasaDuasi',
  },
  {
    name: "Münâcâtü'l-Kur'ân",
    type: 'munacatul-kuran-duasi',
    url: 'dualar/munacatul-kuran-duasi',
    basePath: '/dualar',
    keywords: 'munacatul kuran, dua zikir, Munacatıl Kuran Duası, munacat kuran',
    color: '#f8a5c2',
    pageCount: 16,
    fileName: 'munacatulKuranDuasi',
  },
  {
    name: 'Sabah Namazı Tesbihatı',
    type: 'sabah-namazi-tesbihati',
    url: 'dualar/sabah-namazi-tesbihati',
    basePath: '/dualar',
    keywords:
      'sabah namazı tesbihatı, dua zikir, tesbih, Sabah Namazı Tesbihatı, sabah namazı tesbihat',
    color: '#f8a5c2',
    pageCount: 7,
    fileName: 'sabahNamaziTesbihati',
  },
  {
    name: 'Öğle Namazı Tesbihatı',
    type: 'ogle-namazi-tesbihati',
    url: 'dualar/ogle-namazi-tesbihati',
    basePath: '/dualar',
    keywords:
      'ogle namazı tesbihatı, dua zikir, tesbih, Öğle Namazı Tesbihatı, öğle namazı tesbihat',
    color: '#f8a5c2',
    pageCount: 5,
    fileName: 'ogleNamaziTesbihati',
  },
  {
    name: 'İkindi Namazı Tesbihatı',
    type: 'ikindi-namazi-tesbihati',
    url: 'dualar/ikindi-namazi-tesbihati',
    basePath: '/dualar',
    keywords:
      'ikindi namazı tesbihatı, dua zikir, tesbih, İkindi Namazı Tesbihatı, ikindi namazı tesbihat',
    color: '#f8a5c2',
    pageCount: 6,
    fileName: 'ikindiNamaziTesbihati',
  },
  {
    name: 'Akşam Namazı Tesbihatı',
    type: 'aksam-namazi-tesbihati',
    url: 'dualar/aksam-namazi-tesbihati',
    basePath: '/dualar',
    keywords:
      'aksam namazı tesbihatı, dua zikir, tesbih, Aksam Namazı Tesbihatı, aksam namazı tesbihat',
    color: '#f8a5c2',
    pageCount: 8,
    fileName: 'aksamNamaziTesbihati',
  },
  {
    name: 'Yatsı Namazı Tesbihatı',
    type: 'yatsi-namazi-tesbihati',
    url: 'dualar/yatsi-namazi-tesbihati',
    basePath: '/dualar',
    keywords:
      'yatsi namazı tesbihatı, dua zikir, tesbih, Yatsı Namazı Tesbihatı, yatsi namazı tesbihat',
    color: '#f8a5c2',
    pageCount: 5,
    fileName: 'yatsiNamaziTesbihati',
  },
  {
    name: "Kur'an'dan Rabbena Duaları",
    type: 'kurandan-rabbena-dualari',
    url: 'dualar/kurandan-rabbena-dualari',
    basePath: '/dualar',
    keywords: 'rabbena, dua, kuran, ayet, kurandan rabbena duaları, kuran duaları',
    color: '#f8a5c2',
    pageCount: 3,
    fileName: 'rabbenaDualari',
    sound: true,
  },
  {
    name: 'Namaz Duaları',
    type: 'namaz-dualari',
    url: 'dualar/namaz-dualari',
    basePath: '/dualar',
    keywords: 'namaz duaları, dua, tesbihat, namaz, namaz duaları',
    color: '#f8a5c2',
    pageCount: 11,
    fileName: 'namazDualari',
  },
  {
    name: 'Salli Barik',
    type: 'salli-barik-duasi',
    url: 'dualar/salli-barik-duasi',
    basePath: '/dualar',
    keywords: 'salli barik, dua, namaz, allahumme salli barik, salli barik duası',
    color: '#f8a5c2',
    pageCount: 1,
    fileName: 'salliBarikDuasi',
  },
  {
    name: 'Rabbena',
    type: 'rabbena-duasi',
    url: 'dualar/rabbena-duasi',
    basePath: '/dualar',
    keywords: 'rabbena atina duası, dua, namaz rabbena duasi, rabbena duası',
    color: '#f8a5c2',
    pageCount: 1,
    fileName: 'rabbenaDuasi',
  },
  {
    name: 'Esmaül Hüsna',
    type: 'esmaul-husna',
    url: 'dualar/esmaul-husna',
    basePath: '/dualar',
    keywords: 'esmaul husna, esma-ül hüsna, allahın isimleri, 99 isim',
    color: '#f8a5c2',
    pageCount: 3,
    fileName: 'esmaulHusna',
  },
  {
    name: 'Abdülkâdir Geylânî’nin Hizbü’n-Nasr Duası',
    type: 'hizbun-nasr-duasi',
    url: 'dualar/hizbun-nasr-duasi',
    basePath: '/dualar',
    keywords:
      'abdülkâdir geylânî hizbün nasr duası, abdulkadir geylani hizbun nasr duasi, hizbü’n-nasr, yardım duası',
    color: '#f8a5c2',
    pageCount: 3,
    fileName: 'hizbunNasrDuasi',
  },
  {
    name: 'İmam Şâzilî’nin Hizbü’n-Nasr Duası',
    type: 'imam-sazeli-hizbun-nasr-duasi',
    url: 'dualar/imam-sazeli-hizbun-nasr-duasi',
    basePath: '/dualar',
    keywords:
      'imam şâzilî hizbün nasr duası, imam sazeli hizbun nasr duasi, ebül hasan eş şazeli, hizbü’n-nasr, yardım duası',
    color: '#f8a5c2',
    pageCount: 3,
    fileName: 'imamSazeliHizbunNasrDuasi',
  },
  {
    name: 'Hacet ve Ferahlık Münâcâtı',
    type: 'hacet-ve-ferahlik-munacati',
    url: 'dualar/hacet-ve-ferahlik-munacati',
    basePath: '/dualar',
    keywords:
      'hacet, ferahlık, münâcât, munacat, ihtiyaç, sıkıntı, peygamber duaları, yakarış',
    color: '#f8a5c2',
    pageCount: 6,
    fileName: 'hacetVeFerahlikMunacati',
    isNew: true,
  },
  {
    name: 'Sahîfe-i Seccâdiye Hacet ve İhtiyaç Duası',
    type: 'hacetleri-allahtan-isteme-duasi',
    url: 'dualar/hacetleri-allahtan-isteme-duasi',
    basePath: '/dualar',
    keywords:
      'sahife-i seccadiye, sahifei seccadiye, sahife i seccadiye duası, imam zeynelabidin, hacet duası, ihtiyaç duası, ihtiyac duasi, hacetleri allahtan isteme, 13. dua',
    color: '#f8a5c2',
    pageCount: 4,
    fileName: 'hacetleriAllahtanIstemeDuasi',
    isNew: true,
  },
  {
    name: 'Korunma Duası',
    type: 'korunma-duasi',
    url: 'dualar/korunma-duasi',
    basePath: '/dualar',
    keywords:
      'korunma duası, korunma duasi, koruma duası, korunmak için dua, sığınma duası, nazar duası, nazardan korunma duası, kötülüklerden korunma duası, şerlerden korunma, belalardan korunma duası, hastalıktan korunma duası, düşmandan korunma duası, peygamber duaları',
    color: '#f8a5c2',
    pageCount: 6,
    fileName: 'korunmaDuasi',
    isNew: true,
  },
  {
    name: 'Sizden Gelen Dualar',
    type: 'sizden-gelen-dualar',
    url: 'sizden-gelen-dualar',
    keywords: 'sizden gelen dualar, topluluk duaları, dua paylaş',
    color: '#00d0ff',
    estReadTime: 30,
  },
]

/** Reuses platform-neutral dua timing metadata in the web content catalog. */
export const contentLibrary = contentLibraryEntries.map((entry) => {
  const descriptor = bundledDuaDescriptors.find((item) => item.type === entry.type)
  return descriptor ? { ...entry, estReadTime: descriptor.estReadTime } : entry
})
